import { useState } from "react";
import { Button, Dialog, Select, SelectOption } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";
import { Occurrence } from "../../../models/occurrence";
import { useTasOccurrence } from "../../../hooks/useTasOccurrence";

interface ITasNumberRequiredDialogProps {
  show: boolean;
  occurrence: Occurrence | null;
  loading?: boolean;
  onConfirm: (tasNumber: string) => void;
  onCancel: () => void;
}

const TasNumberRequiredDialog = ({
  show,
  occurrence,
  loading = false,
  onConfirm,
  onCancel,
}: ITasNumberRequiredDialogProps) => {
  const intl = useIntl();
  const [tasNumber, setTasNumber] = useState<string | undefined>(undefined);
  const { tasOccurrences } = useTasOccurrence(occurrence?.vehicleChassis || "", "");

  const handleCancel = () => {
    setTasNumber(undefined);
    onCancel();
  };

  return (
    <Dialog
      show={show}
      title={intl.formatMessage({ id: "intl-msg:kanban.tasNumberRequiredDialog.title" })}
      body={
        <div className="space-y-4">
          <div className="text-color-status-resting">
            {intl.formatMessage({ id: "intl-msg:kanban.tasNumberRequiredDialog.description" })}
          </div>
          <div className="form-group form-group-lg w-full">
            <label htmlFor="tasNumberRequired">{intl.formatMessage({ id: "intl-msg:kanban.tasNumberRequiredDialog.tasNumberLabel" })}</label>
            <Select
              id="tasNumberRequired"
              value={tasNumber ? [tasNumber] : []}
              options={tasOccurrences.map((tas) => ({
                id: tas.tasOccurrenceNumber,
                label: tas.tasOccurrenceNumber,
              })) as SelectOption[]}
              useFilter
              placeholder={intl.formatMessage({ id: "intl-msg:kanban.tasNumberRequiredDialog.tasPlaceholder" })}
              onChange={(e) => setTasNumber(e?.id)}
            />
          </div>
        </div>
      }
      footer={
        <div className="display-flex justify-content-end">
          <Button
            bsStyle="default"
            onClick={handleCancel}
            className="margin-right-10"
            disabled={loading}
          >
            {intl.formatMessage({ id: "intl-msg:occurrence.card.cancel" })}
          </Button>
          <Button
            bsStyle="primary"
            onClick={() => tasNumber && onConfirm(tasNumber)}
            disabled={loading || !tasNumber}
          >
            {loading ? intl.formatMessage({ id: "intl-msg:kanban.tasNumberRequiredDialog.confirming" }) : intl.formatMessage({ id: "intl-msg:occurrence.card.confirm" })}
          </Button>
        </div>
      }
      bsSize={Dialog.SIZE_SM}
      onClose={handleCancel}
    />
  );
};

export default TasNumberRequiredDialog;
